import { IconArrow } from 'common/components/Icons/IconArrow/IconArrow';
import { Checkbox } from 'common/components/Icons/IconCheckbox/IconCheckbox';
import { IOptionSelectItem } from 'common/components/multiSelect/interface';
import { useSelector } from 'react-redux';
import { Amplitude } from 'common/services/amplitude.service';
import Tooltip from '@mui/material/Tooltip';
import { tooltipStyles } from 'common/components/grid/styles/tooltipStyles';
import './selectItem.scss';
import { IconBeta } from '../../../Icons/IconBeta/IconBeta';

export function SelectItem(props: IOptionSelectItem) {
  const { activePageName, activeTabName } = useSelector((state: any) => state.general);
  //Sends true or false. To hide or show a column
  function handleChange() {
    props.option.is_toggled = !props.option.is_toggled;
    Amplitude.save(props.option.is_toggled ? 'ADD_COLUMN' : 'REMOVE_COLUMN', {
      page: activePageName,
      tab: activeTabName,
      column: props.option.label
    });
    props.onChange(props.option);
  }

  //Opens the dropdown and rotate the arrow of the dropdown
  function handleChangeArrow() {
    //I added the condition because of the interface
    if (props.onChangeArrow) props.onChangeArrow(props.toggleArrow);
  }

  const getClassName = (label: string): string => {
    if (props.searchTerm && !label.toLowerCase().includes(props.searchTerm.toLowerCase())) {
      return 'hide';
    }
    return '';
  };
  const labelElement = <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {props.option.label}
        {props.option.icon === 'beta' && <IconBeta />}
      </div>;

  return (
    <>
      {props.option.is_displayable && !props.option.is_hidden && (
        <div className={`option-wrapper ${getClassName(props.option.label)}`}>
          <div className="option" onClick={handleChange} data-testid={`selectItem-${props.option.name}`}>
            <Checkbox active={props.option.is_toggled} />
            {props.option.description ? (
              <Tooltip
                title={
                  <div>
                    <div style={{ marginTop: '4px' }}>{props.option.description}</div>
                  </div>
                }
                placement="top"
                arrow
                componentsProps={tooltipStyles}
              >
                {labelElement}
              </Tooltip>
            ) : (
              labelElement
            )}
          </div>

          {props.showArrow && (
            <div onClick={handleChangeArrow}>
              <IconArrow active={props.toggleArrow} toggleRotate={props.toggleArrow} />
            </div>
          )}
        </div>
      )}
    </>
  );
}
